/**
 * @generated SignedSource<<570643ccd31eb9c0c3ee533bec3ffc3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedFAQQuestion_question$data = {
  readonly answerCount: number | null;
  readonly answers: ReadonlyArray<{
    readonly serviceId: string;
    readonly " $fragmentSpreads": FragmentRefs<"SharedFAQAnswer_answer">;
  } | null> | null;
  readonly id: string;
  readonly title: string | null;
  readonly url: string | null;
  readonly " $fragmentType": "SharedFAQQuestion_question";
};
export type SharedFAQQuestion_question$key = {
  readonly " $data"?: SharedFAQQuestion_question$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedFAQQuestion_question">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedFAQQuestion_question",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answerCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AnswerType",
      "kind": "LinkedField",
      "name": "answers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedFAQAnswer_answer"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QuestionType",
  "abstractKey": null
};

(node as any).hash = "afb63cc356688c0c7eb78ccb1e85b70f";

export default node;
